import React from 'react';
import UploaderField from 'forms/shared/fields/uploader-preview'
import PropTypes from 'prop-types';


const SpaceImages = ({ form }) => {
  return (
    <div className="amenities py-6">
      <p className="font-bold text-primary-black text-xl">Images</p>
      <p className="py-1 text-xs text-gray-600">Max. of 7 Photos</p>
      <div className="w-full">
        <UploaderField
          form={form}
          name="images"
          resize={true}
          acceptedFiles='image/jpg, image/jpeg, image/png'
        />
      </div>
    </div>
  )
}

SpaceImages.propTypes = {
  form: PropTypes.string
}


export default SpaceImages
